module.exports = __webpack_public_path__ + "img/suppliers_grey.ef68fa16.svg";